export const todo = "todo";

const d = new Date();
export const Today = new Date(d.getFullYear(), d.getMonth(), d.getDate());

export const QueryKey = {
  prediction: "prediction",
};
